import {baseBackendRoute} from "../../../../config/generals";
import * as React from "react";
import {IPartner} from "@leap4/entities-discrepancy-common";
import {
    GenericItemsForm,
    GenericItemsUtils,
    Grid,
    IGetAllParams,
    BaseGenericItemsStore, DataGridUtils, setAlert,
    MuiDataGrid,
    MuiIcons,
    Button,
    Typography,
    Home as HomeOutlined
} from "@leap4/frontend";

import {urlService} from "../../../routing/urlsService";
import {RootState} from "../../../../interfaces/root-state.interface";
import {connect, ConnectedProps} from "react-redux";
import {UnAssignDialog} from "./UnAssignDialog";
import {useState} from "react";
import {Link} from "react-router-dom";
import {Server} from "@leap4/auth";
import {OneOrgOnly} from "../../../shared/OneOrgOnly/OneOrgOnly";
type GridColDef = MuiDataGrid.GridColDef;
type GridRenderCellParams = MuiDataGrid.GridRenderCellParams;
const fields = {
    name: 1,
    companyId: 1,
    dataPoint: 1,
    partner: 1,
}

const getParams: IGetAllParams = {
    fields,
}


let columns: GridColDef[];
let store: BaseGenericItemsStore<IPartner & { _id: string, isActive: boolean }>

function renderObj(params: GridRenderCellParams) {
    const obj = params.value as any;
    return obj?.name || 'Unassigned';
}

function renderCSVFormatter(params) {
    return params.value?.name || "Un-Named"
}


function setStoreAndColumns(props, refreshData) {
    const storeAndColumns = GenericItemsUtils.GenerateDefaultStoreAndColumns({
        baseUrl: baseBackendRoute + "/partners/alias/demand",
    }, fields, {
        name: {},
        isActive: {},
        updated: {},
        created: {},
    })

    const editAlias = DataGridUtils.createNewColumn({
        headerName: 'Edit Alias',
        renderCell: (params: GridRenderCellParams) => {
            if (params.row.isManualCreated) {
                return (
                    <Link to={urlService.editAlias(params.id.toString())}><Button
                        variant={'outlined'}
                    >Edit</Button></Link>
                )
            }
            return <></>
        }
        ,
        align: "center",
        headerAlign: "center",
        field: "EditAlias"
    })

    const unAssignColumn = DataGridUtils.createNewColumn({
        headerName: 'UN-Assign',
        renderCell: (params: GridRenderCellParams) => <UnAssignDialog currentRowData={params.row}
                                                                      setAlert={props.setAlert}
                                                                      refreshData={refreshData}/>,
        align: "center",
        headerAlign: "center",
        field: "UNassign"
    })

    store = storeAndColumns.store;
    columns = storeAndColumns.columns;


    columns.find(x => x.field === "dataPoint").renderCell = renderObj;
    columns.find(x => x.field === "dataPoint").valueFormatter = renderCSVFormatter;
    columns.find(x => x.field === "partner").renderCell = renderObj;
    columns.find(x => x.field === "partner").valueFormatter = renderCSVFormatter;
    columns.push(editAlias, unAssignColumn)


}

const mapStateToProps = (state: RootState) => ({
    selectedOrganization: state.auth.selectedOrganizationId
});

const mapActions = {
    setAlert
}

const connector = connect(mapStateToProps, mapActions);
type PropsFromRedux = ConnectedProps<typeof connector>;

const _AliasDemandPartners = (props: PropsFromRedux & { refreshData: () => void }) => {
    const [refreshData, setRefreshData] = useState(false);
    const onRefreshData = () => {
        setRefreshData(!refreshData)
    }
    setStoreAndColumns(props, onRefreshData);

    const lastChosenOrganization = localStorage.getItem(Server.headers.X_ORGANZIZATION).split('-')
    if (lastChosenOrganization.length > 1) {
        return <OneOrgOnly />
    }

    return (
        <GenericItemsForm
            organization={props.selectedOrganization}
            columns={columns}
            store={store}
            shouldRefresh={refreshData}
            breadcrumbs={{
                link: urlService.partnersAliasDemand(),
                text: "Aliases Demand",
                icon: <HomeOutlined/>
            }}
            createButton={{
                to: urlService.createAlias(),
                text: "Create Manual Alias ".toUpperCase()
            }}
            getAllParams={getParams}
            tableProps={{
                pageSize: 50
            }}
        />
    );
};
export const AliasDemandPartners = connector(_AliasDemandPartners)